module.exports = __webpack_public_path__ + "static/img/MegLanning.6e991b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MegLanning.jpg
// module id = SazV
// module chunks = 0